module.exports = __webpack_public_path__ + "static/img/2.5a6edbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/2.png
// module id = Y+dN
// module chunks = 0